import { useState, useEffect } from 'react';
import { $t } from 'hooks/i18n';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';

import { Tag } from "primereact/tag";
export default function DemandcollectionreportPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const [data, setData] = useState([]);
const [loading, setLoading] = useState(false);
const [dateFrom, setDateFrom] = useState(null); // ✅ Date | null
const [dateTo, setDateTo] = useState(null);
const formatDate = (d) => {
    if (!d) return "";
    const date = d instanceof Date ? d : new Date(d);
    if (isNaN(date.getTime())) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};
useEffect(() => {
    if (dateFrom && dateTo) {
        loadData();
    }
}, [dateFrom, dateTo]);
const loadData = async () => {
    if (!dateFrom || !dateTo) return;
    setLoading(true);
    try {
        const from = formatDate(dateFrom); // yyyy-MM-dd
        const to = formatDate(dateTo);     // yyyy-MM-dd
        const res = await fetch(
        `${process.env.REACT_APP_API_PATH}analysis/demand-collection?fromDate=${from}&toDate=${to}`
        );
        const json = await res.json();
        setData(json);
        } catch (err) {
        console.error(err);
        } finally {
        setLoading(false);
    }
};
/* ===== Column Templates ===== */
const dateTemplate = (row) => formatDate(row.transactionDate);
const amountTemplate = (row, field) =>
row[field]?.toLocaleString("en-IN", { minimumFractionDigits: 2 });
const percentTemplate = (row) => {
    const val = row.collPercent || 0;
    const severity = val >= 90 ? "success" : val >= 70 ? "warning" : "danger";
    return <Tag value={`${val.toFixed(2)} %`} severity={severity} />;
};
const exportData = (format) => {
    if (!dateFrom || !dateTo) {
        alert("Please select From & To date");
        return;
    }
    const fromDate = formatDate(dateFrom);
    const toDate = formatDate(dateTo);
    const url = `${process.env.REACT_APP_API_PATH}analysis/demand-collection-export`
    + `?fromDate=${fromDate}&toDate=${toDate}&export=${format}`;
    window.open(url, "_blank");
};
const exportItems = [
{
    label: 'Excel',
    icon: 'pi pi-file-excel',
    command: () => exportData('excel')
},
{
    label: 'CSV',
    icon: 'pi pi-file',
    command: () => exportData('csv')
}
];
	return (
		<main id="DemandcollectionreportPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('demandcollectionreport')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="sm:col-12 lg:col-5 md:col-4 comp-grid" >
                        <div className="">
                            <div className="">
                                <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="single" value={dateFrom}
                                onChange={(e) => setDateFrom(e.target.value)} placeholder={$t('Date From')}   />
                            </div>
                        </div>
                    </div>
                    <div className="sm:col-12 lg:col-5 md:col-4 comp-grid" >
                        <div className="">
                            <div className="">
                                <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="single" value={dateTo}
                                onChange={(e) => setDateTo(e.target.value)} placeholder={$t('Date To')}   />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="">
                    <div className="card">
                        <h3 className="mb-3">Demand vs Collection Report</h3>
                        <DataTable
                            value={data}
                            loading={loading}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 25, 50]}
                            stripedRows
                            showGridlines
                            responsiveLayout="scroll"
                            emptyMessage="No records found"
                            footer={`Total Records: ${data.length}`}
                            >
                            <Column
                                field="transactionDate"
                                header="Date"
                                body={dateTemplate}
                                sortable
                                />
                                <Column
                                    field="branchName"
                                    header="Branch"
                                    sortable
                                    filter
                                    />
                                    <Column
                                        field="groupName"
                                        header="Group"
                                        sortable
                                        filter
                                        />
                                        <Column
                                            field="empName"
                                            header="Employee"
                                            sortable
                                            filter
                                            />
                                            <Column
                                                field="demand"
                                                header="Demand"
                                                body={(row) => amountTemplate(row, "demand")}
                                                className="text-right"
                                                sortable
                                                />
                                                <Column
                                                    field="collected"
                                                    header="Collected"
                                                    body={(row) => amountTemplate(row, "collected")}
                                                    className="text-right"
                                                    sortable
                                                    />
                                                    <Column
                                                        field="due"
                                                        header="Due"
                                                        body={(row) => amountTemplate(row, "due")}
                                                        className="text-right"
                                                        sortable
                                                        />
                                                        <Column
                                                            header="% Collected"
                                                            body={percentTemplate}
                                                            sortable
                                                            />
                                                        </DataTable>
                                                    </div>
                                                    <SplitButton
                                                        label="Export"
                                                        icon="pi pi-download"
                                                        model={exportItems}
                                                        className="p-button-success"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
		</main>
	);
}
